import React from "react";
import { Link } from "react-router-dom";
import { Pagination } from "zina-dogi-react";
import { Badge } from "reactstrap";
import { utils } from "~/utils";
import "./cpo_table.scss";

const titles = [
    "CPO Name",
    "CPO Number",
    "CPO Date",
    "CPO Exp date",
    "CPO Receipt date",
    "Currency",
    "Circle",
    "Customer Material Number",
    "Quantity",
    "CPO Status",
    "OET Name",
    "OET ID",
    // 'OET Status',
    "Run ID",
    "Run ID Status"
];

const CpoTable = ({ cpos, className, pagination }) => {
    return (
        <div {...{ className }}>
            <div className="table-content" style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-striped">
                    <colgroup>
                        <col />
                        <col width="80px" />
                        <col width="90px" />
                        <col width="90px" />
                        <col width="90px" />
                        <col width="80px" />
                        <col width="100px" />
                        <col width="100px" />
                        <col width="75px" />
                        <col width="100px" />
                        <col />
                        <col width="50px" />
                        <col width="50px" />
                        <col width="130px" />
                    </colgroup>
                    <thead className="thead-dark">
                        <tr>
                            {titles &&
                                titles.map((title, index) => (
                                    <th key={`cpo_title_${index}`} scope="col">
                                        {title}
                                    </th>
                                ))}
                        </tr>
                    </thead>
                    <tbody>{computeRows(cpos)}</tbody>
                </table>
            </div>
            <Pagination {...pagination} />
        </div>
    );
};

const computeRows = cpos => {
    if (cpos) {
        const cpo_list = Object.values(cpos);
        if (cpo_list.length !== 0) {
            return cpo_list.map((row, index) => {
                return (
                    <tr key={`cpo_value_${index}`}>
                        <td>{row.cpo.prefix}</td>
                        <td>
                            <Link to={`/detail/${row.cpo.id}`}>{row.cpo.number}</Link>
                        </td>
                        <td>{utils.renderDate(row.cpo.date)}</td>
                        <td>{utils.renderDate(row.cpo_register.effective_to_date)}</td>
                        <td>{utils.renderDate(row.cpo.creation_date)}</td>
                        <td>{row.cpo.currency}</td>
                        <td>{row.cpo_register ? row.cpo_register.circle : null}</td>
                        <td>{row.run ? row.run.oet_item__code : ""}</td>
                        <td>{row.run ? row.run.quantity_spent : ""}</td>
                        <td>{row.cpo_register ? row.cpo_register.status_display : ""}</td>
                        <td>{row.oet ? <Link to={`/tracker/${row.oet.id}`}>{row.oet.name}</Link> : ""}</td>
                        <td>{row.oet ? <Link to={`/tracker/${row.oet.id}`}>{row.oet.id}</Link> : ""}</td>
                        {/* <td>{row.oet ? row.oet.status_display : ''}</td> */}
                        <td>
                            {row.run ? (
                                <Link to={`/run/${row.oet.id}/${row.run.id}/`}>
                                    {row.run.number ? `#${row.run.number}` : ""}
                                </Link>
                            ) : (
                                ""
                            )}
                        </td>
                        <td>
                            {row.run ? row.run.status_display : ""}{" "}
                            {row.run ? (
                                row.run.days_delayed > 0 ? (
                                    <Badge color="danger" pill style={{ float: "right" }}>
                                        {row.run.days_delayed}
                                    </Badge>
                                ) : (
                                    ""
                                )
                            ) : (
                                ""
                            )}
                        </td>
                    </tr>
                );
            });
        }
    }
    return (
        <tr>
            <td colSpan={titles.length}>No data found</td>
        </tr>
    );
};

CpoTable.header = (
    <nav className="navbar">
        <span className="navbar-brand h4">Select CPOs to create massive OET then select process items.</span>
    </nav>
);

export default CpoTable;
